// API
import { api } from '../configs/api/api';

// Models
import {
  ICompany,
  ICompanyFee,
  ICountry,
  ILanguage,
  ISpeciality,
  ISpecialization
} from '../interfaces/core.interfaces';

export const CoreService = {
  fetchCompanyFee: async (): Promise<{ data?: ICompanyFee, error?: string }> => {
    try {
      const axiosResponse = await api.get('/company-fee');
      return { data: axiosResponse.data };
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  fetchLanguagesList: async (): Promise<{ languages: ILanguage[], status: string } | null> => {
    try {
      const axiosResponse = await api.get('/company-languages');
      return axiosResponse.data;
    } catch (error) {
      return null;
    }
  },
  fetchCountriesList: async (): Promise<{ countries: ICountry[], status: string } | null> => {
    try {
      const axiosResponse = await api.get('/company-countries');
      return axiosResponse.data;
    } catch (error) {
      return null;
    }
  },
  fetchSpecialitiesList: async (): Promise<{ specialities: ISpeciality[], status: string } | null> => {
    try {
      const axiosResponse = await api.get('/specialities');
      return axiosResponse.data;
    } catch (error) {
      return null;
    }
  },
  fetchCompaniesList: async (): Promise<{ companies: ICompany[], status: string } | null> => {
    try {
      const axiosResponse = await api.get('/users/companies');
      return axiosResponse.data;
    } catch (error) {
      return null;
    }
  },
  fetchSpecializationsList: async (speciality: ISpeciality[]): Promise<{
    specializations: ISpecialization[],
    status: string
  } | null> => {
    try {
      const axiosResponse = await api.get('/specializations', {
        params: {
          speciality: speciality.map(s => s.id)
        }
      });
      return axiosResponse.data;
    } catch (error) {
      return null;
    }
  }
}
